
import { Button, Form, Input, Modal, Popover, Select } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formItemLayout } from '../utils/antUtils';
import { cancelSbtTemplateEdit, deleteSbtTemplate, templateSbtEditAttr, saveSbtTemplate } from './templateActions';
import { getDateRule } from '../utils/antUtils';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;

class SbtTemplateModalComponent extends Component {

  state = {
    confirmDeleteVisible: false
  }

  handleSubmit = (e) => {

    this.props.form.validateFields((errors) => {
      if (errors) {
        return false;
      }

      this.props.dispatch(saveSbtTemplate(this.props.edit))
    });
  }

  handleCancel = (e) => {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(cancelSbtTemplateEdit());
  }

  deleteConfirmed = () => {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(deleteSbtTemplate(this.props.edit.id));
  }

  onChange(event, attr) {
    this.props.dispatch(templateSbtEditAttr(attr, event.target.value));
  }

  onChangeValue(value, attr) {
    this.props.dispatch(templateSbtEditAttr(attr, value));
  }

  render() {

    if (!this.props.edit) {
      return null;
    }

    const { getFieldDecorator } = this.props.form;

    let confirmPopup = (<div>
      <Button onClick={this.deleteConfirmed}>Ja</Button>
      <Button style={{ marginLeft: 10 }} onClick={() => this.setState({ confirmDeleteVisible: false })}>Nej</Button>
    </div>);

    let footer = this.props.edit.id === -1 ? [] : [<div style={{ float: 'left' }}>
      <Popover visible={this.state.confirmDeleteVisible} placement="topLeft" title={'Är du säker?'} content={confirmPopup} trigger="click">
        <Button type="danger" onClick={() => this.setState({ confirmDeleteVisible: true })} >Radera mall</Button>
      </Popover>
    </div>];

    footer.push(<Button key="back" onClick={this.handleCancel}>Avbryt</Button>);
    footer.push(<Button key="submit" type="primary" onClick={this.handleSubmit}>Spara</Button>);

    return (

      <Modal
        maskClosable={false}
        width={800}
        maskClosable={false}
        title={this.props.edit && this.props.edit.id === -1 ?
          'Ny rättsfallmall' : 'Ändra rättsfallmall'}
        visible={!!this.props.edit}
        onCancel={this.handleCancel}
        footer={footer}
      >
        <div>
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout} label="Mallnamn" >
              {getFieldDecorator('name', { rules: [{ required: true, message: 'Ange ett namn' }], })(
                <Input autoFocus onBlur={(e) => this.onChange(e, 'name')} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Filnamn" >
              {getFieldDecorator('originalFilename')(
                <Input onBlur={(e) => this.onChange(e, 'originalFileName')} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Källa" >
              {getFieldDecorator('sourceId')(
                <Select allowClear style={{ width: '100%' }} showSearch optionFilterProp="children" onChange={(e) => this.onChangeValue(e, 'sourceId')} >
                  {this.props.sources.map((s) => (<Option key={s.id} value={s.id}>{s.fullName} &gt; {s.id}</Option>))}
                </Select>
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Beslutsdatum"  >
              {getFieldDecorator('decisionDateString', { rules: [getDateRule('Ange ett giltigt beslutdatum på formatet: 2017-12-24')], })(
                <Input onBlur={(e) => this.onChange(e, 'decisionDateString')} />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Publikation" >
              {getFieldDecorator('documentSource')(
                <Input onBlur={(e) => this.onChange(e, 'documentSource')} />)}
            </FormItem>
            <FormItem >
              Sammanfattning:
              {getFieldDecorator('preamble')(<TextArea rows={10} onBlur={(e) => this.onChange(e, 'preamble')} />)}
            </FormItem>
            <FormItem >
              Kommentar:
              {getFieldDecorator('content')(<TextArea rows={10} onBlur={(e) => this.onChange(e, 'content')} />)}
            </FormItem>
          </Form>

        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    edit: state.templates.templateSbtEdit,
    sources: state.templates.sbtTemplateSources
  }
};


export default connect(mapStateToProps)(Form.create({
  mapPropsToFields(props) {
    return {
      name: Form.createFormField({ value: props.edit ? props.edit.name : '' }),
      originalFilename: Form.createFormField({ value: props.edit ? props.edit.originalFileName : '' }),
      sourceId: Form.createFormField({ value: props.edit ? props.edit.sourceId : '' }),
      documentSource: Form.createFormField({ value: props.edit ? props.edit.documentSource : '' }),
      preamble: Form.createFormField({ value: props.edit ? props.edit.preamble : '' }),
      content: Form.createFormField({ value: props.edit ? props.edit.content : '' }),
      decisionDateString: Form.createFormField({ value: props.edit ? props.edit.decisionDateString : '' })
    }
  }
})(SbtTemplateModalComponent));



// WEBPACK FOOTER //
// ./src/templates/sbtTemplateModalComponent.js